import {
  IndexerLuckyStarStatistics,
  IndexerMainNumberStatistics,
} from "../web3/Types";

export class Frequency {
  constructor(id: bigint, frequency: bigint, lastClaim: bigint) {
    this.id = id;
    this.frequency = frequency;
    this.lastClaim = lastClaim;
  }

  id: bigint;
  frequency: bigint;
  lastClaim: bigint;

  static fromGraph(
    data: IndexerLuckyStarStatistics | IndexerMainNumberStatistics,
  ): Frequency {
    if ("mainNumber" in data) {
      return new Frequency(data.mainNumber, data.count, data.lastDrawNumber);
    } else {
      return new Frequency(data.luckyStar, data.count, data.lastDrawNumber);
    }
  }
}
